<form
  (ngSubmit)="onSubmit($event)"
  [formGroup]="form"
>
  <ion-list
    lines="inset"
    [inset]="false"
  >
    @for (fieldGroup of visibleFieldGroups; track fieldGroup.id || $index) {
      <rota-setupable-field-group
        [fieldGroup]="fieldGroup"
        [form]="form"
        [dependentFieldsPerOptionId]="dependentFieldsPerOptionId"
        [requestModel]="requestModel"
        (optionSelect)="handleOptionSelect($event)"
      >
      </rota-setupable-field-group>
    }
  </ion-list>

  <div class="buttons-wrapper">
    <ion-button
      fill="outline"
      color="primary"
      [rotaDisable]="form.pending"
      (click)="cancel.emit()"
      ion-button
      type="button"
      (click)="goBack()"
    >
      <ion-icon
        slot="start"
        name="close-circle-outline"
      ></ion-icon>
      {{ 'General_Cancel' | translate }}
    </ion-button>
    <ion-button
      [expand]="true"
      color="primary"
      [rotaDisable]="form.pending || isEmpty"
      type="submit"
    >
      {{ 'Send' | translate }}
      <ion-icon
        class="send-icon"
        slot="end"
        name="send"
      ></ion-icon>
    </ion-button>
  </div>
</form>
